// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1AlDP","header":"PatientBlock_header__3JDc9","label":"PatientBlock_label__1jCjb","option":"PatientBlock_option__1PzU3"};